// extracted by mini-css-extract-plugin
module.exports = {"center":"Spinner_center__17MRX","wave":"Spinner_wave__tO23w"};